exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-sort-tablet[data-v-21d1a049]{margin-right:10px;display:none}.language-wrap-inner[data-v-21d1a049]{display:flex;margin-left:15px}@media screen and (max-width:1000px){.btn-sort-tablet[data-v-21d1a049]{display:block}}@media screen and (max-width:768px){.btn-sort-tablet[data-v-21d1a049]{display:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-21d1a049","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/products/components/ProductLanguageOption.vue
// module id = 539
// module chunks = 187